import type { IconProps } from '.';

/**
 * External Icon SVG component.
 *
 * IMPORTANT:
 * Importing a SVG directly tells the compiler to use Webpack, thus including the whole file in the bundle.
 * By using a component instead, we can leverage server components and return HTML directly from the server.
 */

const ExternalIcon = ({ className }: IconProps) => (
  <svg
    role="presentation"
    aria-hidden="true"
    focusable="false"
    fill="none"
    width="32"
    height="32"
    viewBox="0 0 29 29"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.7776 9.86587L7.57614 22.0674L6.56599 21.0572L18.7675 8.85572L7.06523 8.85575L7.07107 7.42014H21.2132V21.5623L19.7776 21.5681L19.7776 9.86587Z"
      fill="black"
    />
  </svg>
);

export default ExternalIcon;
